jQuery( function( $ ) {
	$( document ).ready( function() {

		homeJS = ( function() {

			var

				init = function() {
					_initHomeMasonry();
				},

				_initHomeMasonry = function() {

					var _toShow = $( $( '.psr__row.hidden' )[0] );

					var _buildMasonry = function() {
						console.log( 'WPS: Build Masonry' );
						$( '.psr__row' ).each( function() {
							if ( window.matchMedia( '( min-width: 768px )' ).matches ) {
								var firstTile    = $( this ).find( ':nth-child(1) .rp__inner' ),
								secondTile       = $( this ).find( ':nth-child(2) .rp__inner' ),
								thirdTile        = $( this ).find( ':nth-child(3) .rp__inner' ),
								secondBigTile    = $( this ).find( ':nth-child(5)' );
								secondMiddleTile = $( this ).find( ':nth-child(6)' );
								firstTileHeight  = firstTile.outerHeight(),
								secondTileHeight = secondTile.outerHeight(),
								thirdTileHeight  = thirdTile.outerHeight(),
								firstMargin      = firstTileHeight - secondTileHeight,
								secondMargin     = firstTileHeight - thirdTileHeight,

								$( secondBigTile ).css( { 'margin-top': - firstMargin } );
								$( secondMiddleTile ).css( { 'margin-top': - secondMargin } );
							}
						});
					}

					setTimeout( function() {
						_buildMasonry();
					}, 500 );

					$( '.psr__button > a' ).click( function() {

						if ( _toShow.length !== 0 ) {
							_toShow.removeClass( 'hidden' );
							_buildMasonry();

							if ( 0 !== _toShow.next( '.psr__row' ).length ) {
								_toShow = _toShow.next( '.psr__row' );
							} else {
								$( this ).remove();
							}
						}
					} );
				}
			;

			return {
				init: init
			};

		}() );

	});
});
